module.exports = __webpack_public_path__ + "img/HowToCook.e6d935f1.svg";